import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import useProfitMargin from "./useProfitMargin";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { profitMarginFields, handleSubmit, setData, setErrors } = useProfitMargin();
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    axios.get('categories-shops').then(res => {
      setData({ data: res?.data });
    });
  }, []);

  const addProfitMargin = data => {
    axios.post('profitMargins', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Profit margin has been created successfully!', {
            icon: "success",
          });
          navigate("/profit-margins");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add profit margin">
      <form className="form w-100 row" onSubmit={handleSubmit(addProfitMargin)}>
        {profitMarginFields}
        <div className="col-12 text-left mt-10">
          <SubmitButton
            title="Add"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}